import { z } from 'zod';
import {
  innSchema,
  ogrnSchema,
  kppSchema,
  optionalEmailSchema,
  phoneSchema,
  hexColorSchema,
} from './common';

/**
 * Onboarding company form — создание титульной компании юр.лица.
 *
 * Совпадает с logic'ом frontend-vite/src/pages/onboarding/company.tsx
 * (function validate()) до zod-рефактора:
 * - name: обязательное (trim + non-empty)
 * - inn / ogrn / kpp: optional, но если заданы — формат
 * - director_email: optional, если задан — формат
 * - default_currency_code: enum, default RUB
 * - brand_color: hex
 */

export const CURRENCY_CODES = ['RUB', 'USD', 'EUR', 'KZT', 'BYN', 'UZS'] as const;
export type CurrencyCode = (typeof CURRENCY_CODES)[number];

export const onboardingCompanySchema = z.object({
  name: z.string().trim().min(1, 'Введите название'),
  short_name: z.string().optional(),
  legal_entity_name: z.string().optional(),
  inn: innSchema,
  ogrn: ogrnSchema,
  kpp: kppSchema,
  legal_address: z.string().optional(),
  actual_address: z.string().optional(),
  director_name: z.string().optional(),
  director_phone: phoneSchema,
  director_email: optionalEmailSchema,
  default_currency_code: z.enum(CURRENCY_CODES),
  brand_color: hexColorSchema,
});
export type OnboardingCompanyForm = z.infer<typeof onboardingCompanySchema>;
